import {
  BASE_URL,
  CHECK_PROMOTION_AVAILABLE_FOR_USER,
  FETCH_GENERATED_USERNAME,
  GET_PRODUCTS,
  SEND_TO_PROCESSOR,
} from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';


export const DEFAULT_POST_PARAMS = {
  originalDomain: BASE_URL || new URL(document.URL).origin,
  paymentType: 'CC',
  returnPath: '/checkout',
};

export const getPurchaseError = (reason) => {
  switch (reason) {
    case 'ALREADY_HAS_MEMBERSHIP':
      return 'You already have active membership';
    case 'LOGIN_REQUIRED':
      return 'Your session timed out. Please log in again';
    default:
      return 'Something went wrong, please try again later';
  }
};

const PARALLEL_DOMAINS = ['nakednewslive.com', 'nudenews.com', 'nakednews-qa.staging.smart-x.dev', 'theprogramwithnothingtohide.com'];

const MEMBERSHIP_OFFER_URLS = [
  '/account/purchase',
  '/lifetime-promo',
  '/lifetime-promo-playboy',
  '/black-friday-sale-2024',
  '/black-friday-cyber-monday-sale-aff-2024',
  '/xmas-2024',
  '/2025-march-madness-promo'
];

const isParallelDomain = (value) => PARALLEL_DOMAINS.some((domain) => value.includes(domain));

export const generateSiteSubcat = (originalDomain, anchorShortUrl, productType) => {
  let domainName = originalDomain;
  const protocolRegex = /(^\w+:|^)\/\//;

  if (process.env.REACT_APP_DEV || isParallelDomain(domainName)) {
    domainName = 'https://www.nakednews.com';
  }

  // Ensure the domain name does not have trailing slashes
  domainName = domainName.replace(/\/+$/, '');

  if (productType === 'MEMBERSHIP' || MEMBERSHIP_OFFER_URLS.includes(anchorShortUrl)) {

    return domainName.
      replace(protocolRegex, '');
  }

  // Concatenate domain name and anchor short URL
  let combinedUrl = `${domainName}/${anchorShortUrl}`;

  // Remove any double slashes in the URL except for the protocol part
  combinedUrl = combinedUrl.replace(/([^:]\/)\/+/g, '$1');

  // Remove the 'www.' part
  combinedUrl = combinedUrl.replace(/^https?:\/\/www\./, 'https://');

  // Normalize the URL by removing protocol and 'www.'
  const normalizedUrl = combinedUrl.replace(protocolRegex, ''). // Remove protocol
    replace(/^www\./, ''); // Remove 'www.'

  return normalizedUrl;
};


export const redirectToProcessor = (url, params, closeTipping, closeModal) => {
  let buildUrl = `${url}?`;
  let parsedKey = '';

  if (params) {
    for (const key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) {
        continue;
      }
      parsedKey =
        `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}&`;
      buildUrl += parsedKey;
    }
  }
  window.location.href = buildUrl;
  if (closeTipping) {
    closeTipping();
  } else if (closeModal) {
    closeModal();
  }
};

export const getPaymentProcessor = (processorId, priceId, username, processorData, extraPayload) => {
  const url = SEND_TO_PROCESSOR.replace(
    '{username}',
    encodeURIComponent(username)
  ).
    replace('{processorId}', encodeURIComponent(processorId)).
    replace('{priceId}', encodeURIComponent(priceId));

  return callApi(
    url,
    'post',
    {},
    JSON.stringify({
      ...processorData,
      ...extraPayload,
    }),
    { 'content-type': 'application/json; charset=utf-8' },
    false,
    false
  );
};

export const decidePromoInfo = (
  promoPage,
  activeCampaign,
  promoBlockedByAtc,
  promoCodeInfo,
  anchorPortalCampaign,
  NNLivePromoPage,
  NNPromoPage,
  fanDiscountActive,
  hasAtc,
  hasPromoInURL,
  data,
  email,
) => {
  const processorData = data;
  // use passThrough to send params to Payment that need to be sent back to NN
  processorData.passThrough = processorData?.passThrough || {};
  if (hasPromoInURL?.affiliateCode) {
    processorData.passThrough.affiliateCode = hasPromoInURL?.affiliateCode;
    processorData.passThrough.campaignAffiliateCode = hasPromoInURL?.affiliateCode;
  }

  if (hasPromoInURL?.hash) {
    processorData.passThrough.hash = hasPromoInURL?.hash;
  }

  if (promoPage && activeCampaign?.name && !promoBlockedByAtc) {
    processorData.passThrough.affiliateCode = activeCampaign.affiliateCode;
    processorData.passThrough.campaignAffiliateCode = activeCampaign.affiliateCode;
  } else if (promoPage && activeCampaign?.name && promoBlockedByAtc) {
    processorData.passThrough.affiliateCode = hasAtc;
    processorData.passThrough.campaignAffiliateCode = hasAtc;
  }
  if (promoCodeInfo?.affiliateCode) {
    processorData.passThrough.affiliateCode = promoCodeInfo?.affiliateCode;
    processorData.passThrough.campaignAffiliateCode = promoCodeInfo?.affiliateCode;
  }
  if (NNLivePromoPage) {
    processorData.passThrough.affiliateCode = 'nnlpromo20220505';
    processorData.passThrough.campaignAffiliateCode = 'nnlpromo20220505';
  }
  if (NNPromoPage) {
    processorData.passThrough.affiliateCode = 'nnpromo20220505';
    processorData.passThrough.campaignAffiliateCode = 'nnpromo20220505';
  }
  if (hasAtc) {
    processorData.passThrough.affiliateCode = hasAtc;
  }

  processorData.affiliateCode = processorData?.passThrough?.affiliateCode;
  processorData.pcode = activeCampaign?.affiliateCode;
  if (activeCampaign?.affiliateCode) {
    processorData.affiliateCode = hasAtc || activeCampaign?.affiliateCode;
    processorData.passThrough.campaignAffiliateCode = activeCampaign?.affiliateCode;
  }

  if (Object.keys(processorData.passThrough).length < 1) {
    delete processorData.passThrough;
  }

  if (email) {
    processorData.email = email;
  }

  if (activeCampaign?.affiliateCode === 'NNLIVEMRSK5') {
    processorData.passThrough.campaignAffiliateCode = activeCampaign?.affiliateCode;
    processorData.affiliateCode = hasAtc || activeCampaign?.affiliateCode;
  }

  return processorData;
};

export const addDataForGiftAndItemProduct = (data, anchorShortUrl, isPunishedByBroadcaster, punishCanBeLiftedByTip, priceToLiftPunish, activeProgram) => {
  const dataForProcessor = data;
  if (
    !dataForProcessor.siteSubcat &&
    (dataForProcessor.productType === 'GIFT' ||
      dataForProcessor.productType === 'ITEM')
  ) {
    if (anchorShortUrl) {
      dataForProcessor.siteSubcat = generateSiteSubcat(
        dataForProcessor.originalDomain,
        anchorShortUrl
      );
    }
  }

  return dataForProcessor;
};

export const formatRecurringPeriodString = (period, type) => {
  const year = 12;
  const week = 7;

  if (parseInt(period, 10) === year && String(type).toLowerCase() === 'month') {
    return 'annually';
  }
  if (parseInt(period, 10) === week && String(type).toLowerCase() === 'day') {
    return 'weekly';
  }

  return `${type}ly`;
};

export const fetchUserName = (email, password) => callApi(
  FETCH_GENERATED_USERNAME,
  'post',
  {},
  { email, password },
  { 'content-type': 'application/json; charset=utf-8' },
  false
);

export const checkIfUserHasPromotion = (hash, hasLimitedValidity) => {
  let URL = CHECK_PROMOTION_AVAILABLE_FOR_USER;

  if (hasLimitedValidity) {
    URL += '/verify';
  }

  return callApi(URL, 'GET', { hash });
};

export const decideOriginalDomain = () => {
  const IS_DEV_ENV = window.location.hostname.includes('local');
  if (BASE_URL && IS_DEV_ENV) {
    return BASE_URL;
  }

  return new URL(document.URL).origin;
};

export const getProductsUrl = (packageType) => GET_PRODUCTS.replace('{productType}', packageType);
